var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomShoppingCart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1E2969",
    cx: 6.732,
    cy: 21.384,
    r: 2.376
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1E2969",
    cx: 21.384,
    cy: 21.384,
    r: 2.376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.78 17.424H5.94a.792.792 0 0 1-.783-.674L2.882 1.584H0V0h3.564c.392 0 .725.287.783.674L4.9 4.356h18.86a.793.793 0 0 1 .78.926l-1.98 11.484a.792.792 0 0 1-.78.658z",
    fill: "#9A5238"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomShoppingCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-shopping-cart.78fb9b47c7a82b79b9d421f2315b0351.svg";